import api from "./index";
import {AdminCommentsTemplateData, GetPaginatedResponse, PendingCountResponse, UpdateWebsiteItem} from "../../../types";
import {Comment, User, FilterWords} from "../Components/List/Item/CommentsItem";
import {Website} from "../Components/List/Item/SitesItem";
import {COMMENT_STATE} from "../routes/Comments/filters";
import {RequestParams} from "../Components/List/hooks";
import {URL_STATE} from "../routes/URLs/filters";
import {URL} from "../Components/List/Item/URLItem";
import {USER_STATE} from "../routes/Users/filters";
import {WEBSITE_STATE} from "../routes/Websites/filters";
import { HistoryItem } from "admin/App/Components/History/types"
import { FILTER_STATE } from "../routes/FilterWords";

export const getMe = (): Promise<User> => {
  return api.get<User>('/me')
}

export const getPendingCommentCount = (): Promise<PendingCountResponse> => {
  return api.get<PendingCountResponse>('/admin/pending_count')
}

export const getWebsiteById = (id: string): Promise<Website> => {
  return api.get<Website>(`/admin/websites/${encodeURIComponent(id)}`)
}

export const updateWebsiteSettings = (updates: UpdateWebsiteItem): Promise<void> => {
  return api.post(`/admin/websites`, updates)
}

export const signout = (): Promise<{ link: string }> => {
  return api.get(`/signout?origin=${document.location.href}`)
}

export const getComments = (params: RequestParams<COMMENT_STATE>): Promise<GetPaginatedResponse<AdminCommentsTemplateData>> => {
  return api.get<GetPaginatedResponse<AdminCommentsTemplateData>>('/admin/comments', {
    params,
  })
}

export const postCommentAction = (type: string, ids: ReadonlyArray<number>): Promise<void> => {
  return  api.post('/admin/comments/actions', {type, ids})
}

export const getCommentById = (id: number): Promise<Comment> => {
  return api.get<Comment>(`/comments/${id}`)
}

export const getParentCommentById = (id: number): Promise<boolean> => {
  return api.get<boolean>(`/comments/checkParent/${id}`)
}

export const getCommentHistoriesById = (id: number): Promise<ReadonlyArray<HistoryItem>> => {
  return api.get<ReadonlyArray<HistoryItem>>(`/admin/comment-histories/${id}`)
}

export const getUrls = (params: RequestParams<URL_STATE>): Promise<GetPaginatedResponse<URL>> => {
  return api.get<GetPaginatedResponse<URL>>('/admin/urls', {
    params,
  })
}

export const getUsers = (params: RequestParams<USER_STATE>): Promise<GetPaginatedResponse<User>> => {
  return api.get<GetPaginatedResponse<User>>('/admin/users', {
    params,
  })
}

export const getFilterWords = (params: RequestParams<FILTER_STATE>): Promise<GetPaginatedResponse<FilterWords>> => {
  
  return api.get<GetPaginatedResponse<FilterWords>>('admin/forbidden-words', {
    params,
  })
}

export const updateFilterWords = (id: string, forbiddenWord: string): Promise<void> => {
  
  return api.post(`admin/forbidden-words/${id}`, { 
    forbiddenWord
  })
}

export const postFilterWords = (forbiddenWord: string): Promise<void> => {
  
  return api.post('admin/forbidden-words', {
    forbiddenWord
  })
}

export const deleteFilterWords = (ids: ReadonlyArray<string>): Promise<void> => {
  
  return api.post(`admin/forbidden-words/remove/list`, { ids })
}

export const postUserAction = (type: string, ids: ReadonlyArray<number>): Promise<void> => {
  return  api.post('/admin/users/actions', {type, ids})
}

export const getWebsites = (params: RequestParams<WEBSITE_STATE>): Promise<GetPaginatedResponse<Website>> => {
  return api.get<GetPaginatedResponse<Website>>('/admin/websites', {
    params,
  })
}

export const getAllWebsites = (): Promise<GetPaginatedResponse<Website>> => {
  return api.get<GetPaginatedResponse<Website>>('/admin/websites')
}

export const enableUrlSetting = (url: string): Promise<void> => {
  return api.post(`/admin/url/enable`, {url: url})
}

export const disableUrlSetting = (url: string): Promise<void> => {
  return api.post(`/admin/url/disable`, {url: url})
}

export const searchComments = (keyword: string, type: string, page: number): Promise<GetPaginatedResponse<AdminCommentsTemplateData>> => {
  return api.get<GetPaginatedResponse<AdminCommentsTemplateData>>(`/admin/comments/search?keyword=${keyword}&type=${type}&page=${page}`)
}